import React from "react";
import "../../App.css";

type Props = {
  children?: React.ReactNode;
  tabBarDisabled?: boolean;
  style?: React.CSSProperties;
  id?: string;
  className?: string;
};

const ContentContainer: React.FC<Props> = (props) => {
  return (
    <div
      id={props.id}
      className={`contentContainer ${props.tabBarDisabled ? "contentContainerNoTabs" : ""}${props.className ? ` ${props.className}` : ""}`}
      style={props.style}
    >
      {props.children}
    </div>
  );
};

export default ContentContainer;
